import { render, staticRenderFns } from "./AccessibilityMenu.vue?vue&type=template&id=5341c9ec&scoped=true&"
import script from "./AccessibilityMenu.vue?vue&type=script&lang=js&"
export * from "./AccessibilityMenu.vue?vue&type=script&lang=js&"
import style0 from "./AccessibilityMenu.vue?vue&type=style&index=0&id=5341c9ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5341c9ec",
  null
  
)

/* custom blocks */
import block0 from "./AccessibilityMenu.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports